// extracted by mini-css-extract-plugin
module.exports = {"faq":"SectionFaq_faq__NQerO","faq__title":"SectionFaq_faq__title__WqU71","faq__list-container":"SectionFaq_faq__list-container__hFcO4"};